/**
 * Curated product list — variant select price + sold-out button state.
 */
(function () {
  'use strict';

  function initForm(form) {
    if (form.dataset.cplInitialized === 'true') {
      return;
    }
    form.dataset.cplInitialized = 'true';

    var select = form.querySelector('[data-curated-variant-select]');
    if (!select) {
      return;
    }

    var wrap = form.closest('.curated-product-list__form-wrap');
    var priceEl = form.closest('product-item')?.querySelector('[data-curated-price]');
    var addButton = form.querySelector('[data-curated-add-button]');

    function syncFromSelect() {
      var option = select.options[select.selectedIndex];
      if (!option) {
        return;
      }

      if (priceEl && option.dataset.priceHtml) {
        priceEl.innerHTML = option.dataset.priceHtml;
      }

      if (addButton) {
        var available = !option.disabled;
        addButton.disabled = !available;
        addButton.textContent = available
          ? addButton.dataset.labelAdd || addButton.textContent
          : addButton.dataset.labelSoldOut || addButton.textContent;
      }
    }

    if (addButton && wrap) {
      if (!addButton.dataset.labelAdd && wrap.dataset.labelAdd) {
        addButton.dataset.labelAdd = wrap.dataset.labelAdd;
      }
      if (!addButton.dataset.labelSoldOut && wrap.dataset.labelSoldOut) {
        addButton.dataset.labelSoldOut = wrap.dataset.labelSoldOut;
      }
    }

    select.addEventListener('change', syncFromSelect);
    syncFromSelect();
  }

  function boot(root) {
    (root || document).querySelectorAll('.curated-product-list__form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
